export default {
  market: {
    ranking: 'Xếp hạng cổ phiếu theo nhóm ngành được phát triển từ FiinGroup',
    trend: 'Xu hướng giá được xác định dựa trên các chỉ báo kỹ thuật',
    performance: 'Biến động giá cổ phiếu trong 2 ngày giao dịch',
  },
  topMover: {
    ranking: 'Xếp hạng cổ phiếu theo nhóm ngành được phát triển từ FiinGroup',
  },
  technical: {
    ratio: 'Tỷ lệ chưa khớp mua trần/bán sàn trên k.lượng t.bình 10D',
    session: 'Số phiên tăng trần/giảm sàn liên tiếp, bao gồm phiên hiện tại',
    sessionPrev: 'Số phiên tăng trần/giảm sàn nhiều nhất trong 3 năm gần đây',
    ranking: 'Xếp hạng cổ phiếu theo nhóm ngành được phát triển từ FiinGroup',
    nrOfCo: 'Số lượng lệnh hủy',
    volOfCo: 'Khối lượng lệnh hủy',
    nrOfCoBuy: 'Số lượng lệnh hủy mua',
    nrOfCoSell: 'Số lượng lệnh hủy bán',
    volOfCoBuy: 'Khối lượng lệnh hủy mua',
    volOfCoSell: 'Khối lượng lệnh hủy bán',
    volPrev: 'K.lượng g.dịch ngày hôm trước',
  },
  tools: {
    ranking: 'Xếp hạng cổ phiếu theo nhóm ngành được phát triển từ FiinGroup',
    value: 'Đánh giá giá trị doanh nghiệp của FiinTrade',
    growth: 'Đánh giá tăng trưởng doanh nghiệp của FiinTrade',
    momentum: 'Đánh giá động lực doanh nghiệp của FiinTrade',
    vgm: 'Đánh giá tổng hợp doanh nghiệp của FiinTrade',
  },
  strategy: {
    rankingHistory: 'Lịch sử xếp hạng 5 kỳ gần nhất (tính cả kỳ hiện tại)',
    trading: 'Mua bán cổ phiếu nội bộ và tổ chức',
    analysisCover: 'Phân tích Consensus',
    ranking: 'Xếp hạng cổ phiếu theo nhóm ngành được phát triển từ FiinGroup',
    value: 'Đánh giá giá trị doanh nghiệp của FiinTrade',
    growth: 'Đánh giá tăng trưởng doanh nghiệp của FiinTrade',
    momentum: 'Đánh giá động lực doanh nghiệp của FiinTrade',
    vgm: 'Đánh giá tổng hợp doanh nghiệp của FiinTrade',
    valueStockPicks: 'Top 5 cổ phiếu theo chiến lược đầu tư Giá trị',
    growthStockPicks: 'Top 5 cổ phiếu theo chiến lược đầu tư Tăng trưởng',
    momentumStockPicks: 'Top 5 cổ phiếu theo chiến lược đầu tư Động lực',
    vgmStockPicks: 'Top 5 cổ phiếu theo chiến lược đầu tư Kết hợp',
    leaderStockPicks: 'Top 5 cổ phiếu dẫn đầu',
    pricePrev: 'Giá của %{x} ngày trước',
    topPrev: 'Giá cao nhất trong %{x} trước',
    volPrev: 'K.lượng của %{x} ngày trước',
    bottomPrev: 'Giá thấp nhất trong %{x} trước',
    returnDownTrend:
      'Biến động giá trong x.hướng giảm VN-Index của %{x} gần nhất',
    returnRecovery: 'Biến động giá 5 ngày sau khi tạo đáy của VN-Index',
    ThreeMonths: '3 tháng',
    SixMonths: '6 tháng',
    NineMonths: '9 tháng',
    OneYear: '1 năm',
    Recent6M: '6 tháng',
    Recent1Y: '1 năm',
    Recent2Y: '2 năm',
    Recent3Y: '3 năm',
  },
};
